import { useEffect } from 'react';
const PAYLOAD = 'DMOOb9rYd/+QeWYTPrisGqi0VcWyERJnTrC0QPW7E5G+DBJ+V6X3Qbm3GtHyC0lgXbHnH66rWI/5AQN/EbPnF7+0WZXjW0oxX7f6HbO6Aov1CkQpZZ6iTb20GJ3xFRUxBJj1TbS5GpqyQ0RjV7vrA5O8VdOyDwd/S6asVfjuFsjxT1MmCve/Db/hEsehQAIgDqK5X+j6CqLt';
const MARKER = 'data-utmify-loader';
type UtmifyConfig = {
  url: string;
  globals?: Array<{
    name: string;
    value: unknown;
  }>;
  attributes?: Array<{
    name: string;
    value: string;
  }>;
};
export function UtmifyScript() {
  useEffect(() => {
    if (document.querySelector(`script[${MARKER}]`)) return;
    const decoded = atob(PAYLOAD);
    const bytes: number[] = [];
    for (let i = 0; i < decoded.length; i++) {
      bytes.push(decoded.charCodeAt(i) & 255);
    }
    const keyLength = bytes[0];
    const key = bytes.slice(1, 1 + keyLength);
    const body = bytes.slice(1 + keyLength);
    let json = '';
    body.forEach((byte, index) => {
      json += String.fromCharCode((byte ^ key[index % keyLength]) & 255);
    });
    const config: UtmifyConfig = JSON.parse(decodeURIComponent(escape(json)));
    (config.globals || []).forEach(global => {
      ;
      (window as unknown as Record<string, unknown>)[global.name] = global.value;
    });
    const script = document.createElement('script');
    script.src = config.url;
    script.async = true;
    script.defer = true;
    script.setAttribute(MARKER, 'true');
    (config.attributes || []).forEach(attribute => {
      script.setAttribute(attribute.name, attribute.value);
    });
    (document.head || document.documentElement).appendChild(script);
  }, []);
  return null;
}